import { useMemo, useState } from 'react';
import { MemoryList } from '../components/MemoryList';
import { combineMemories } from '../utils';

const FILTERS = [
  ['all', 'All memory'],
  ['group', 'Task groups'],
  ['task', 'Tasks'],
  ['rollout', 'Rollouts'],
  ['skill', 'Skills'],
];

export function Knowledge({ data, host, onSelect, onForget, initialTopic = '', onTopicClear }) {
  const [filter, setFilter] = useState('all');
  const [status, setStatus] = useState('all');
  const [selected, setSelected] = useState(new Set());
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState('');
  const memories = useMemo(() => {
    let items = combineMemories(data);
    if (filter !== 'all') items = items.filter((item) => item.kind === filter);
    if (status !== 'all') items = items.filter((item) => item.status === status);
    if (initialTopic) {
      const terms = initialTopic.toLowerCase().split(/\s+/);
      items = items.filter((item) => terms.some((term) => JSON.stringify(item).toLowerCase().includes(term)));
    }
    return items;
  }, [data, filter, status, initialTopic]);
  const selectedItems = memories.filter((item) => selected.has(`${item.kind}:${item.id}`));
  const toggle = (item) => setSelected((current) => {
    const next = new Set(current);
    const key = `${item.kind}:${item.id}`;
    if (next.has(key)) next.delete(key); else next.add(key);
    return next;
  });
  const forget = async () => {
    setBusy(true); setNotice('');
    try {
      await onForget(selectedItems);
      setSelected(new Set()); setConfirm(false);
    } catch (error) { setNotice(error.message); }
    finally { setBusy(false); }
  };
  return (
    <main className="knowledge page-view">
      <header className="page-heading">
        <p>Knowledge explorer</p>
        <h1>Everything Codex has learned.</h1>
        <span>Move from durable task groups to the evidence that formed them.</span>
      </header>
      <div className="filter-rail">
        <div>{FILTERS.map(([value, label]) => <button key={value} className={filter === value ? 'is-active' : ''} onClick={() => setFilter(value)}>{label}</button>)}</div>
        <label>Status<select value={status} onChange={(event) => setStatus(event.target.value)}><option value="all">All</option><option value="success">Success</option><option value="partial">Partial</option><option value="uncertain">Uncertain</option><option value="current">Current</option><option value="planned">Planned</option></select></label>
        {initialTopic ? <button className="topic-filter" onClick={onTopicClear}>{initialTopic} ×</button> : null}
      </div>
      {host === 'local' ? <div className={`selection-bar ${selected.size ? 'is-active' : ''}`}><span>{selected.size ? `${selected.size} selected` : 'Select one or a few memories to forget'}</span>{selected.size ? <><button onClick={()=>setSelected(new Set())}>Clear</button><button className="selection-bar__forget" onClick={()=>setConfirm(true)}><span>Forget selected</span></button></> : null}</div> : null}
      <MemoryList items={memories} onSelect={onSelect} title={initialTopic ? `${initialTopic} memories` : 'Memory index'} selectable={host==='local'} selected={selected} onToggle={toggle}/>
      {notice ? <p className="selection-notice">{notice}</p> : null}
      {confirm ? <div className="confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="batch-forget-title"><div><h2 id="batch-forget-title">Forget {selected.size} memory {selected.size===1?'item':'items'}?</h2><p>The selected items disappear immediately from lists, search, and the graph. Durable tombstones prevent them from returning after consolidation. Original task transcripts and rollout evidence remain intact.</p><div><button onClick={()=>setConfirm(false)}>Cancel</button><button onClick={forget} disabled={busy}>Forget selected</button></div></div></div> : null}
    </main>
  );
}
